export const configurationTypeEnum = {
  DEVICE_LIST: 'DEVICE_LIST',
  SETUP: 'SETUP',
} as const

export type ConfigurationTypeEnum = (typeof configurationTypeEnum)[keyof typeof configurationTypeEnum]

export type ConfigurationType = ConfigurationTypeEnum